<ui-icon icon="analytics"></ui-icon>
<br>
<br>
<ui-icon icon="widgets"></ui-icon>
<br>
<br>
<ui-icon icon="loop"></ui-icon>
